import * as React from "react";
import {formatTextToReactElement} from "../utils";
interface RegisterDescriptionTooltipProps {
    message: string | null;
}


export const RegisterDescriptionTooltip: React.FC<RegisterDescriptionTooltipProps> = ({message}) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const [marginTop, setMarginTop] = React.useState(0);
    const [contained, setContained] = React.useState(false);
    const tooltipMessage = React.useMemo(() => formatTextToReactElement(message), [message]);

    React.useEffect(() => {
        if (ref.current) {
            const element = ref.current;
            const parent = $(element).closest(".danfoss-table").get(0);

            const tmpContained = parent.scrollTop < element.offsetTop && element.offsetTop + element.clientHeight < parent.scrollTop + parent.clientHeight;
            setContained(tmpContained);
            setMarginTop(tmpContained ? 30 - parent.scrollTop : -7 - element.offsetHeight - parent.scrollTop);
        }
    }, []);

    return (
        <div
            ref={ref}
            className={contained ? "rw-bottom-tooltip" : "rw-top-tooltip"}
            style={{marginTop}}
        >
            {tooltipMessage}
        </div>
    );
}